import UserTypesSelector from './UserTypesSelector';

export default UserTypesSelector;
